<template>
  <div class="market-group" :class="{ 'closed-market-group': props.closed }">
    <div class="market-group-head" @click="/* props.closed = !props.closed */">
      <span class="market-group-kind" v-if="kind">{{ kind }}</span>
      <span class="market-group-name">{{ name }}</span>
    </div>
    <div class="market-list">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    period: Number,
    kind: String,
    name: String,
    closed: Boolean
  },
  data () {
    return {
      props: {
        closed: this.closed || (this.$route.params.period && this.period && this.period !== this.$route.params.period)
      }
    }
  }
}
</script>

<style scoped>
.market-group-head { background: rgba(255, 255, 255, .015); border-radius: 5px; display: inline-block; cursor: pointer; font-size: 16px; height: 32px; line-height: 32px; margin-top: 10px; padding: 0 10px; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.market-group-kind { color: #342d6e; margin-right: 10px; }

.closed-market-group { display: inline-block; }
.closed-market-group .market-group-head { background: rgba(255, 255, 255, .025); margin: 10px 5px 0 0; }
.closed-market-group .market-list { display: none; }

.market-group-head:hover,
.closed-market-group .market-group-head:hover { background: rgba(255, 255, 255, .05); }
</style>



// WEBPACK FOOTER //
// src/components/sports/eventview/MarketGroup.vue